module.exports = __webpack_public_path__ + "img/bags-shopping.6f960ba6.svg";